import React from "react";

export default class FontLink extends React.Component {
  fontSource() {
    let { asset } = this.props;
    if (
      asset.attributes.asset_data.web_font_id &&
      asset.attributes.asset_data.web_font_type === "google"
    ) {
      return "Google Fonts";
    } else if (
      asset.attributes.asset_data.web_font_id &&
      asset.attributes.asset_data.web_font_type === "adobe"
    ) {
      return "Adobe Fonts";
    }
    return "Fonts.com";
  }

  fontUrl() {
    let { asset } = this.props;
    let fontName = asset.attributes.name.replace(/\s+/g, "+").toLowerCase();
    let fontId = asset.attributes.asset_data.web_font_id.replace(/\s+/g, "+");
    if (
      asset.attributes.asset_data.web_font_id &&
      asset.attributes.asset_data.web_font_type === "google"
    ) {
      return `https://www.google.com/fonts#UsePlace:use/Collection:${fontId}`;
    } else if (
      asset.attributes.asset_data.web_font_id &&
      asset.attributes.asset_data.web_font_type === "adobe"
    ) {
      return `https://edgewebfonts.adobe.com/fonts#/?collection=${
        asset.attributes.asset_data.web_font_id
      }`;
    }
    return `http://www.fonts.com/search/all-fonts?searchtext=${fontName}`;
  }

  render() {
    return (
      <a href={this.fontUrl()} target="_blank">
        <button className="noline button primary">
          <div className="attachment-icon">
            <svg viewBox="0 0 59.38 50">
              <polygon
                fill="#FFFFFF"
                points="34.38 0 34.38 9.38 21.88 9.38 21.88 50 12.5 50 12.5 9.38 0 9.38 0 0 34.38 0"
              />
              <polygon
                fill="#FFFFFF"
                points="59.38 28.13 50 28.13 50 50 40.63 50 40.63 28.13 31.25 28.13 31.25 18.75 59.38 18.75 59.38 28.13"
              />
            </svg>
          </div>
          &nbsp; {this.fontSource()}
        </button>
      </a>
    );
  }
}
